import React, { Component } from "react";
import PropTypes from "prop-types";
import S3BrowserModal from "./S3BrowserModal";
import { Modal } from "react-bootstrap";

class TemplatesFormS3Browser extends Component {
  static propTypes = {
    getS3FilebrowserDirectory: PropTypes.string.isRequired,
    onRef: PropTypes.func.isRequired,
    insertImageUrl: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      s3_status: "hide",
      s3_browser_directory: null,
      showModal: false
    };
  }

  componentDidMount() {
    this.props
      .getS3FilebrowserDirectory(localStorage.getItem('lastSiteUUID'))
      .then(response => {
        if (response.payload.status == 200) {
          this.setState({
            s3_status: "show",
            s3_browser_directory: response.payload.data.directory
          });
        }
      });
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  insertImageUrl(file) {
    this.props.insertImageUrl(file);
    this.closeModal();
  }

  render() {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this.closeModal.bind(this)}
        backdrop="static"
        keyboard={false}
        autoFocus={true}
        enforceFocus={true}
        className="filebrowser_modal"
      >
        <Modal.Header closeButton={true}>
          <Modal.Title id="contained-modal-title-lg">File Browser</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <S3BrowserModal
            creds_url={
              process.env.API_ROOT_URL +
              "/s3_browser/access_token?X-Site-UUID=" +
              localStorage.getItem('lastSiteUUID') +
              "&directory=" +
              this.state.s3_browser_directory
            }
            directory={this.state.s3_browser_directory}
            insert={this.insertImageUrl.bind(this)}
            status={this.state.s3_status}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default TemplatesFormS3Browser;
